import { JsonDecoder, Ok } from 'ts.data.json';

export const propsDecoder = <TypedProps>(
  decoder: JsonDecoder.Decoder<TypedProps>,
  props: any
) => {
  const shouldFail: boolean = process.env.FAIL_DECODERS
    ? JSON.parse(process.env.FAIL_DECODERS)
    : false;
  const decoded = decoder.decode(props);
  if (decoded instanceof Ok) {
    return decoded.value;
  }
  if (shouldFail) {
    throw new Error(decoded.error);
  } else {
    // eslint-disable-next-line no-console
    console.error(decoded.error);
  }
  return props as TypedProps;
};
